import React, {useEffect, useState} from "react"
import {useParams} from "react-router-dom"
import CategoryChart from "./CategoryChart"
import {useUserPreferences} from "../../../common/contexts/UserPreferencesContext"

interface TmsDashboardProps {
	customerId: string
	onRemind?: boolean
	showExploreButton?: boolean
}

const TmsDashboard = ({customerId, onRemind, showExploreButton}: TmsDashboardProps) => {
	const {translations} = useUserPreferences()
	const [remind, setRemind] = useState(onRemind)

	useEffect(() => {
		setRemind(onRemind)
	}, [onRemind])

	return (
		<section className='card-container margin-top-20'>
			<div
				className='parent-dashboard'
				style={{
					width: "100%", // Ensure full width
					maxWidth: "1200px", // Prevent overriding parent maxWidth
					margin: "0 auto", // Center horizontally
					padding: "20px", // Match the original padding from tmsAssessmentResult
					boxSizing: "border-box" // Include padding in width/height calculations
				}}
			>
				<div className='dashboard__title-container'>
					<h2>{translations.tmsCMCB || "Crisis Management Capacity Breakdown"}</h2>
				</div>
				<CategoryChart
					customerId={customerId}
					showExploreButton={showExploreButton}
					showRecommendedButton={true}
					onRemind={remind}
				/>
			</div>
		</section>
	)
}

export default TmsDashboard
